
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BUILD_RELEASE_TOKEN } from "./environments/build-release.token";

declare global {
  interface Window {
    __chromium_devtools_metrics_reporter?: (payload: string) => void;
    __FORLAB_BUILD_VERSION__?: string;
  }
}

if (typeof window !== 'undefined' && typeof window.__chromium_devtools_metrics_reporter !== 'function') {
  // Prevent DevTools live-metrics injection from throwing when hook is absent.
  window.__chromium_devtools_metrics_reporter = () => undefined;
}

if (typeof window !== "undefined") {
  window.__FORLAB_BUILD_VERSION__ = BUILD_RELEASE_TOKEN;
}

if (environment.production) {
  enableProdMode();
  if (window) { // to remove all console.log() in prod mode
    window.console.log = function () { };
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
